import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NumAnnoFilterComponent} from '../../../general-components/filter/num-anno-filter/num-anno-filter.component';
import {MinimumCommModel} from '../../../../models/MinimumCommModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {MinimumCommService} from '../service-minimum-comm/minimum-comm.service';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-filter-minimum-comm',
  templateUrl: './filter-minimum-comm.component.html',
  styleUrls: ['./filter-minimum-comm.component.scss']
})
export class FilterMinimumCommComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Output() dataFiltered = new EventEmitter<any>();
  @Input() showNewEditDelete?: boolean;
  @Input() reportSection?: boolean;

  @ViewChild(NumAnnoFilterComponent, { static: true }) numAnnoFilterComponent;

  filter: MinimumCommModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private minimumCommService: MinimumCommService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.filter = new MinimumCommModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER));
    }
  }


  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    this.numAnnoFilterComponent.reset();
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER, JSON.stringify(this.filter));

    this.filterTable();
  }

  getAllFilters() {
    this.filter.anno = this.numAnnoFilterComponent.optionSelected;
  }


  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.minimumCommService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.minimumCommService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.minimumCommService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Minimum commitment' + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Minimum commitment' + ' - ' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');

          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  interceptYearChange(event) {
    if (!this.reportSection) {
      this.intermittentFilterButton(true);
    }
  }

  getDate(){
    const date = new Date();

    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  ngOnDestroy(): void {

  }

}
